// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_LogicValues_B4 from "../Data.LogicValues.B4/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semigroup_Foldable from "../Data.Semigroup.Foldable/index.js";
import * as Data_Semigroup_Traversable from "../Data.Semigroup.Traversable/index.js";
import * as Data_Show from "../Data.Show/index.js";
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var bimap = /* #__PURE__ */ Data_Bifunctor.bimap(Data_Bifunctor.bifunctorEither);
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_LogicValues_B4.eqB);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Ordering.semigroupOrdering);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordInt);
var append2 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var Implies = /* #__PURE__ */ (function () {
    function Implies(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Implies.create = function (value0) {
        return function (value1) {
            return new Implies(value0, value1);
        };
    };
    return Implies;
})();
var Equiv = /* #__PURE__ */ (function () {
    function Equiv(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Equiv.create = function (value0) {
        return function (value1) {
            return new Equiv(value0, value1);
        };
    };
    return Equiv;
})();
var And = /* #__PURE__ */ (function () {
    function And(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    And.create = function (value0) {
        return function (value1) {
            return new And(value0, value1);
        };
    };
    return And;
})();
var Or = /* #__PURE__ */ (function () {
    function Or(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Or.create = function (value0) {
        return function (value1) {
            return new Or(value0, value1);
        };
    };
    return Or;
})();
var Neg = /* #__PURE__ */ (function () {
    function Neg(value0) {
        this.value0 = value0;
    };
    Neg.create = function (value0) {
        return new Neg(value0);
    };
    return Neg;
})();
var Leaf = /* #__PURE__ */ (function () {
    function Leaf(value0) {
        this.value0 = value0;
    };
    Leaf.create = function (value0) {
        return new Leaf(value0);
    };
    return Leaf;
})();
var ValueExpr = function (x) {
    return x;
};
var value = function ($556) {
    return ValueExpr(Leaf.create(Data_Either.Left.create($556)));
};
var showExpr = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        show: function (v) {
            if (v instanceof Leaf) {
                return show(v.value0);
            };
            if (v instanceof Implies) {
                return "(" + (Data_Show.show(showExpr(dictShow))(v.value0) + (" => " + (Data_Show.show(showExpr(dictShow))(v.value1) + ")")));
            };
            if (v instanceof Equiv) {
                return "(" + (Data_Show.show(showExpr(dictShow))(v.value0) + (" == " + (Data_Show.show(showExpr(dictShow))(v.value1) + ")")));
            };
            if (v instanceof And) {
                return "(" + (Data_Show.show(showExpr(dictShow))(v.value0) + (" && " + (Data_Show.show(showExpr(dictShow))(v.value1) + ")")));
            };
            if (v instanceof Or) {
                return "(" + (Data_Show.show(showExpr(dictShow))(v.value0) + (" || " + (Data_Show.show(showExpr(dictShow))(v.value1) + ")")));
            };
            if (v instanceof Neg) {
                return "!" + Data_Show.show(showExpr(dictShow))(v.value0);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 114, column 1 - line 120, column 44): " + [ v.constructor.name ]);
        }
    };
};
var showValueExpr = function (dictShow) {
    var showEither = Data_Either.showEither(dictShow);
    return function (dictShow1) {
        var show = Data_Show.show(showExpr(showEither(dictShow1)));
        return {
            show: function (v) {
                return show(v);
            }
        };
    };
};
var precedence = function (v) {
    if (v instanceof Equiv) {
        return 1;
    };
    if (v instanceof Implies) {
        return 2;
    };
    if (v instanceof Or) {
        return 3;
    };
    if (v instanceof And) {
        return 4;
    };
    if (v instanceof Neg) {
        return 5;
    };
    if (v instanceof Leaf) {
        return 6;
    };
    throw new Error("Failed pattern match at Data.LogicExpr.AST (line 70, column 1 - line 70, column 38): " + [ v.constructor.name ]);
};
var renderWith = function (f) {
    return function (expr) {
        var pWeak = function (next) {
            if (precedence(expr) > precedence(next)) {
                return "(" + (renderWith(f)(next) + ")");
            };
            if (Data_Boolean.otherwise) {
                return renderWith(f)(next);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 109, column 5 - line 110, column 73): " + [ next.constructor.name ]);
        };
        var pStrong = function (next) {
            if (precedence(expr) >= precedence(next)) {
                return "(" + (renderWith(f)(next) + ")");
            };
            if (Data_Boolean.otherwise) {
                return renderWith(f)(next);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 111, column 5 - line 112, column 74): " + [ next.constructor.name ]);
        };
        if (expr instanceof Leaf) {
            return f(expr.value0);
        };
        if (expr instanceof Equiv) {
            return pStrong(expr.value0) + (" == " + pStrong(expr.value1));
        };
        if (expr instanceof Implies) {
            return pStrong(expr.value0) + (" => " + pWeak(expr.value1));
        };
        if (expr instanceof And) {
            return pWeak(expr.value0) + (" && " + pWeak(expr.value1));
        };
        if (expr instanceof Or) {
            return pWeak(expr.value0) + (" || " + pWeak(expr.value1));
        };
        if (expr instanceof Neg) {
            return "!" + pWeak(expr.value0);
        };
        throw new Error("Failed pattern match at Data.LogicExpr.AST (line 101, column 21 - line 107, column 28): " + [ expr.constructor.name ]);
    };
};
var nodeType = function (v) {
    if (v instanceof Implies) {
        return "Implies";
    };
    if (v instanceof Equiv) {
        return "Equiv";
    };
    if (v instanceof And) {
        return "And";
    };
    if (v instanceof Or) {
        return "Or";
    };
    if (v instanceof Neg) {
        return "Neg";
    };
    if (v instanceof Leaf) {
        return "Leaf";
    };
    throw new Error("Failed pattern match at Data.LogicExpr.AST (line 78, column 1 - line 78, column 39): " + [ v.constructor.name ]);
};
var newtypeValueExpr = {
    Coercible0: function () {
        return undefined;
    }
};
var valueExprToCompose = function ($557) {
    return Data_Functor_Compose.Compose(unwrap($557));
};
var neg$prime = function (v) {
    if (v instanceof Neg) {
        return v.value0;
    };
    return new Neg(v);
};
var trimBoolValues = function (v) {
    var go = function (v1) {
        if (v1 instanceof Leaf) {
            return map(Leaf.create)(v1.value0);
        };
        if (v1 instanceof Implies) {
            var v2 = go(v1.value0);
            if (v2 instanceof Data_Either.Left && v2.value0) {
                return go(v1.value1);
            };
            if (v2 instanceof Data_Either.Left && !v2.value0) {
                return new Data_Either.Left(true);
            };
            if (v2 instanceof Data_Either.Right) {
                var v3 = go(v1.value1);
                if (v3 instanceof Data_Either.Left && v3.value0) {
                    return new Data_Either.Left(true);
                };
                if (v3 instanceof Data_Either.Left && !v3.value0) {
                    return new Data_Either.Right(neg$prime(v2.value0));
                };
                if (v3 instanceof Data_Either.Right) {
                    return new Data_Either.Right(new Implies(v2.value0, v3.value0));
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 316, column 24 - line 319, column 53): " + [ v3.constructor.name ]);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 313, column 26 - line 319, column 53): " + [ v2.constructor.name ]);
        };
        if (v1 instanceof And) {
            var v2 = go(v1.value0);
            if (v2 instanceof Data_Either.Left && v2.value0) {
                return go(v1.value1);
            };
            if (v2 instanceof Data_Either.Left && !v2.value0) {
                return new Data_Either.Left(false);
            };
            if (v2 instanceof Data_Either.Right) {
                var v3 = go(v1.value1);
                if (v3 instanceof Data_Either.Left && v3.value0) {
                    return new Data_Either.Right(v2.value0);
                };
                if (v3 instanceof Data_Either.Left && !v3.value0) {
                    return new Data_Either.Left(false);
                };
                if (v3 instanceof Data_Either.Right) {
                    return new Data_Either.Right(new And(v2.value0, v3.value0));
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 323, column 24 - line 326, column 49): " + [ v3.constructor.name ]);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 320, column 22 - line 326, column 49): " + [ v2.constructor.name ]);
        };
        if (v1 instanceof Or) {
            var v2 = go(v1.value0);
            if (v2 instanceof Data_Either.Left && v2.value0) {
                return new Data_Either.Left(true);
            };
            if (v2 instanceof Data_Either.Left && !v2.value0) {
                return go(v1.value1);
            };
            if (v2 instanceof Data_Either.Right) {
                var v3 = go(v1.value1);
                if (v3 instanceof Data_Either.Left && v3.value0) {
                    return new Data_Either.Left(true);
                };
                if (v3 instanceof Data_Either.Left && !v3.value0) {
                    return new Data_Either.Right(v2.value0);
                };
                if (v3 instanceof Data_Either.Right) {
                    return new Data_Either.Right(new Or(v2.value0, v3.value0));
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 330, column 24 - line 333, column 48): " + [ v3.constructor.name ]);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 327, column 21 - line 333, column 48): " + [ v2.constructor.name ]);
        };
        if (v1 instanceof Equiv) {
            var v2 = go(v1.value0);
            if (v2 instanceof Data_Either.Left && v2.value0) {
                return go(v1.value1);
            };
            if (v2 instanceof Data_Either.Left && !v2.value0) {
                return bimap(not)(neg$prime)(go(v1.value1));
            };
            if (v2 instanceof Data_Either.Right) {
                var v3 = go(v1.value1);
                if (v3 instanceof Data_Either.Left && v3.value0) {
                    return new Data_Either.Right(v2.value0);
                };
                if (v3 instanceof Data_Either.Left && !v3.value0) {
                    return new Data_Either.Right(neg$prime(v2.value0));
                };
                if (v3 instanceof Data_Either.Right) {
                    return new Data_Either.Right(new Equiv(v2.value0, v3.value0));
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 337, column 24 - line 340, column 51): " + [ v3.constructor.name ]);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 334, column 24 - line 340, column 51): " + [ v2.constructor.name ]);
        };
        if (v1 instanceof Neg) {
            return bimap(not)(neg$prime)(go(v1.value0));
        };
        throw new Error("Failed pattern match at Data.LogicExpr.AST (line 311, column 10 - line 341, column 43): " + [ v1.constructor.name ]);
    };
    return go(v);
};
var isValue = function (v) {
    if (v instanceof Leaf && v.value0 instanceof Data_Either.Left) {
        return true;
    };
    return false;
};
var isTerm = function (v) {
    if (v instanceof Leaf && v.value0 instanceof Data_Either.Right) {
        return true;
    };
    return false;
};
var heytingAlgebraValueExpr = function (dictHeytingAlgebra) {
    var implies = Data_HeytingAlgebra.implies(dictHeytingAlgebra);
    var conj1 = Data_HeytingAlgebra.conj(dictHeytingAlgebra);
    var disj = Data_HeytingAlgebra.disj(dictHeytingAlgebra);
    var not1 = Data_HeytingAlgebra.not(dictHeytingAlgebra);
    return {
        ff: value(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        tt: value(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        implies: function (v) {
            return function (v1) {
                if (v instanceof Leaf && (v.value0 instanceof Data_Either.Left && (v1 instanceof Leaf && v1.value0 instanceof Data_Either.Left))) {
                    return value(implies(v.value0.value0)(v1.value0.value0));
                };
                return new Implies(unwrap(v), unwrap(v1));
            };
        },
        conj: function (v) {
            return function (v1) {
                if (v instanceof Leaf && (v.value0 instanceof Data_Either.Left && (v1 instanceof Leaf && v1.value0 instanceof Data_Either.Left))) {
                    return value(conj1(v.value0.value0)(v1.value0.value0));
                };
                return new And(unwrap(v), unwrap(v1));
            };
        },
        disj: function (v) {
            return function (v1) {
                if (v instanceof Leaf && (v.value0 instanceof Data_Either.Left && (v1 instanceof Leaf && v1.value0 instanceof Data_Either.Left))) {
                    return value(disj(v.value0.value0)(v1.value0.value0));
                };
                return new Or(unwrap(v), unwrap(v1));
            };
        },
        not: function (v) {
            if (v instanceof Leaf && v.value0 instanceof Data_Either.Left) {
                return value(not1(v.value0.value0));
            };
            if (v instanceof Neg) {
                return v.value0;
            };
            return new Neg(unwrap(v));
        }
    };
};
var heytingAlgebraExpr = function (dictHeytingAlgebra) {
    var implies = Data_HeytingAlgebra.implies(dictHeytingAlgebra);
    var conj1 = Data_HeytingAlgebra.conj(dictHeytingAlgebra);
    var disj = Data_HeytingAlgebra.disj(dictHeytingAlgebra);
    var not1 = Data_HeytingAlgebra.not(dictHeytingAlgebra);
    return {
        ff: new Leaf(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        tt: new Leaf(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        implies: function (v) {
            return function (v1) {
                if (v instanceof Leaf && v1 instanceof Leaf) {
                    return new Leaf(implies(v.value0)(v1.value0));
                };
                return new Implies(v, v1);
            };
        },
        conj: function (v) {
            return function (v1) {
                if (v instanceof Leaf && v1 instanceof Leaf) {
                    return new Leaf(conj1(v.value0)(v1.value0));
                };
                return new And(v, v1);
            };
        },
        disj: function (v) {
            return function (v1) {
                if (v instanceof Leaf && v1 instanceof Leaf) {
                    return new Leaf(disj(v.value0)(v1.value0));
                };
                return new Or(v, v1);
            };
        },
        not: function (v) {
            if (v instanceof Leaf) {
                return new Leaf(not1(v.value0));
            };
            if (v instanceof Neg) {
                return v.value0;
            };
            return new Neg(v);
        }
    };
};
var functorExpr = {
    map: function (f) {
        return function (m) {
            if (m instanceof Implies) {
                return new Implies(Data_Functor.map(functorExpr)(f)(m.value0), Data_Functor.map(functorExpr)(f)(m.value1));
            };
            if (m instanceof Equiv) {
                return new Equiv(Data_Functor.map(functorExpr)(f)(m.value0), Data_Functor.map(functorExpr)(f)(m.value1));
            };
            if (m instanceof And) {
                return new And(Data_Functor.map(functorExpr)(f)(m.value0), Data_Functor.map(functorExpr)(f)(m.value1));
            };
            if (m instanceof Or) {
                return new Or(Data_Functor.map(functorExpr)(f)(m.value0), Data_Functor.map(functorExpr)(f)(m.value1));
            };
            if (m instanceof Neg) {
                return new Neg(Data_Functor.map(functorExpr)(f)(m.value0));
            };
            if (m instanceof Leaf) {
                return new Leaf(f(m.value0));
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 0, column 0 - line 0, column 0): " + [ m.constructor.name ]);
        };
    }
};
var map1 = /* #__PURE__ */ Data_Functor.map(functorExpr);
var functorValueExpr = {
    map: function (f) {
        return function (m) {
            return map1(map(f))(m);
        };
    }
};
var foldableExpr = {
    foldr: function (v) {
        return function (v1) {
            return function (v2) {
                if (v2 instanceof Leaf) {
                    return v(v2.value0)(v1);
                };
                if (v2 instanceof Implies) {
                    return Data_Foldable.foldr(foldableExpr)(v)(Data_Foldable.foldr(foldableExpr)(v)(v1)(v2.value1))(v2.value0);
                };
                if (v2 instanceof And) {
                    return Data_Foldable.foldr(foldableExpr)(v)(Data_Foldable.foldr(foldableExpr)(v)(v1)(v2.value1))(v2.value0);
                };
                if (v2 instanceof Or) {
                    return Data_Foldable.foldr(foldableExpr)(v)(Data_Foldable.foldr(foldableExpr)(v)(v1)(v2.value1))(v2.value0);
                };
                if (v2 instanceof Equiv) {
                    return Data_Foldable.foldr(foldableExpr)(v)(Data_Foldable.foldr(foldableExpr)(v)(v1)(v2.value1))(v2.value0);
                };
                if (v2 instanceof Neg) {
                    return Data_Foldable.foldr(foldableExpr)(v)(v1)(v2.value0);
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 242, column 1 - line 255, column 21): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
            };
        };
    },
    foldl: function (v) {
        return function (v1) {
            return function (v2) {
                if (v2 instanceof Leaf) {
                    return v(v1)(v2.value0);
                };
                if (v2 instanceof Implies) {
                    return Data_Foldable.foldl(foldableExpr)(v)(Data_Foldable.foldl(foldableExpr)(v)(v1)(v2.value0))(v2.value1);
                };
                if (v2 instanceof And) {
                    return Data_Foldable.foldl(foldableExpr)(v)(Data_Foldable.foldl(foldableExpr)(v)(v1)(v2.value0))(v2.value1);
                };
                if (v2 instanceof Or) {
                    return Data_Foldable.foldl(foldableExpr)(v)(Data_Foldable.foldl(foldableExpr)(v)(v1)(v2.value0))(v2.value1);
                };
                if (v2 instanceof Equiv) {
                    return Data_Foldable.foldl(foldableExpr)(v)(Data_Foldable.foldl(foldableExpr)(v)(v1)(v2.value0))(v2.value1);
                };
                if (v2 instanceof Neg) {
                    return Data_Foldable.foldl(foldableExpr)(v)(v1)(v2.value0);
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 242, column 1 - line 255, column 21): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
            };
        };
    },
    foldMap: function (dictMonoid) {
        return Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictMonoid.Semigroup0());
    }
};
var foldable1Expr = {
    foldMap1: function (dictSemigroup) {
        var append3 = Data_Semigroup.append(dictSemigroup);
        return function (v) {
            return function (v1) {
                if (v1 instanceof Leaf) {
                    return v(v1.value0);
                };
                if (v1 instanceof Implies) {
                    return append3(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value0))(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value1));
                };
                if (v1 instanceof And) {
                    return append3(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value0))(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value1));
                };
                if (v1 instanceof Or) {
                    return append3(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value0))(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value1));
                };
                if (v1 instanceof Equiv) {
                    return append3(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value0))(Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value1));
                };
                if (v1 instanceof Neg) {
                    return Data_Semigroup_Foldable.foldMap1(foldable1Expr)(dictSemigroup)(v)(v1.value0);
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 262, column 1 - line 280, column 45): " + [ v.constructor.name, v1.constructor.name ]);
            };
        };
    },
    foldr1: function (v) {
        return function (v1) {
            if (v1 instanceof Leaf) {
                return v1.value0;
            };
            if (v1 instanceof Implies) {
                return Data_Foldable.foldr(foldableExpr)(v)(Data_Semigroup_Foldable.foldr1(foldable1Expr)(v)(v1.value1))(v1.value0);
            };
            if (v1 instanceof And) {
                return Data_Foldable.foldr(foldableExpr)(v)(Data_Semigroup_Foldable.foldr1(foldable1Expr)(v)(v1.value1))(v1.value0);
            };
            if (v1 instanceof Or) {
                return Data_Foldable.foldr(foldableExpr)(v)(Data_Semigroup_Foldable.foldr1(foldable1Expr)(v)(v1.value1))(v1.value0);
            };
            if (v1 instanceof Equiv) {
                return Data_Foldable.foldr(foldableExpr)(v)(Data_Semigroup_Foldable.foldr1(foldable1Expr)(v)(v1.value1))(v1.value0);
            };
            if (v1 instanceof Neg) {
                return Data_Semigroup_Foldable.foldr1(foldable1Expr)(v)(v1.value0);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 262, column 1 - line 280, column 45): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    foldl1: function (v) {
        return function (v1) {
            if (v1 instanceof Leaf) {
                return v1.value0;
            };
            if (v1 instanceof Implies) {
                return Data_Foldable.foldl(foldableExpr)(v)(Data_Semigroup_Foldable.foldl1(foldable1Expr)(v)(v1.value0))(v1.value1);
            };
            if (v1 instanceof And) {
                return Data_Foldable.foldl(foldableExpr)(v)(Data_Semigroup_Foldable.foldl1(foldable1Expr)(v)(v1.value0))(v1.value1);
            };
            if (v1 instanceof Or) {
                return Data_Foldable.foldl(foldableExpr)(v)(Data_Semigroup_Foldable.foldl1(foldable1Expr)(v)(v1.value0))(v1.value1);
            };
            if (v1 instanceof Equiv) {
                return Data_Foldable.foldl(foldableExpr)(v)(Data_Semigroup_Foldable.foldl1(foldable1Expr)(v)(v1.value0))(v1.value1);
            };
            if (v1 instanceof Neg) {
                return Data_Semigroup_Foldable.foldl1(foldable1Expr)(v)(v1.value0);
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 262, column 1 - line 280, column 45): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Foldable0: function () {
        return foldableExpr;
    }
};
var foldableCompose = /* #__PURE__ */ Data_Foldable.foldableCompose(foldableExpr)(Data_Foldable.foldableEither);
var foldr = /* #__PURE__ */ Data_Foldable.foldr(foldableCompose);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(foldableCompose);
var foldMap = /* #__PURE__ */ Data_Foldable.foldMap(foldableCompose);
var foldableValueExpr = {
    foldr: function (f) {
        return function (y) {
            var $558 = foldr(f)(y);
            return function ($559) {
                return $558(valueExprToCompose($559));
            };
        };
    },
    foldl: function (f) {
        return function (x) {
            var $560 = foldl(f)(x);
            return function ($561) {
                return $560(valueExprToCompose($561));
            };
        };
    },
    foldMap: function (dictMonoid) {
        var foldMap1 = foldMap(dictMonoid);
        return function (f) {
            var $562 = foldMap1(f);
            return function ($563) {
                return $562(valueExprToCompose($563));
            };
        };
    }
};
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(foldableValueExpr);
var freeTerms = function (dictOrd) {
    var $564 = Data_Array.nub(dictOrd);
    return function ($565) {
        return $564(fromFoldable($565));
    };
};
var freeTerms$prime = function (dictFoldable) {
    var fromFoldable1 = Data_Array.fromFoldable(Data_Foldable.foldableCompose(dictFoldable)(foldableValueExpr));
    return function (dictOrd) {
        var $566 = Data_Array.nub(dictOrd);
        return function ($567) {
            return $566(fromFoldable1(Data_Functor_Compose.Compose($567)));
        };
    };
};
var traversableExpr = {
    traverse: function (dictApplicative) {
        return Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApplicative.Apply0());
    },
    sequence: function (dictApplicative) {
        return Data_Semigroup_Traversable.sequence1(traversable1Expr)(dictApplicative.Apply0());
    },
    Functor0: function () {
        return functorExpr;
    },
    Foldable1: function () {
        return foldableExpr;
    }
};
var traversable1Expr = {
    traverse1: function (dictApply) {
        var map2 = Data_Functor.map(dictApply.Functor0());
        var apply1 = Control_Apply.apply(dictApply);
        return function (v) {
            return function (v1) {
                if (v1 instanceof Leaf) {
                    return map2(Leaf.create)(v(v1.value0));
                };
                if (v1 instanceof Implies) {
                    return apply1(map2(Implies.create)(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value0)))(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value1));
                };
                if (v1 instanceof And) {
                    return apply1(map2(And.create)(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value0)))(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value1));
                };
                if (v1 instanceof Or) {
                    return apply1(map2(Or.create)(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value0)))(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value1));
                };
                if (v1 instanceof Equiv) {
                    return apply1(map2(Equiv.create)(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value0)))(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value1));
                };
                if (v1 instanceof Neg) {
                    return map2(Neg.create)(Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(v)(v1.value0));
                };
                throw new Error("Failed pattern match at Data.LogicExpr.AST (line 290, column 1 - line 297, column 33): " + [ v.constructor.name, v1.constructor.name ]);
            };
        };
    },
    sequence1: function (dictApply) {
        return Data_Semigroup_Traversable.traverse1(traversable1Expr)(dictApply)(identity);
    },
    Foldable10: function () {
        return foldable1Expr;
    },
    Traversable1: function () {
        return traversableExpr;
    }
};
var evaluate = function (dictHeytingAlgebra) {
    var implies = Data_HeytingAlgebra.implies(dictHeytingAlgebra);
    var conj1 = Data_HeytingAlgebra.conj(dictHeytingAlgebra);
    var disj = Data_HeytingAlgebra.disj(dictHeytingAlgebra);
    var not1 = Data_HeytingAlgebra.not(dictHeytingAlgebra);
    return function (v) {
        if (v instanceof Leaf) {
            return v.value0;
        };
        if (v instanceof Implies) {
            return implies(evaluate(dictHeytingAlgebra)(v.value0))(evaluate(dictHeytingAlgebra)(v.value1));
        };
        if (v instanceof And) {
            return conj1(evaluate(dictHeytingAlgebra)(v.value0))(evaluate(dictHeytingAlgebra)(v.value1));
        };
        if (v instanceof Or) {
            return disj(evaluate(dictHeytingAlgebra)(v.value0))(evaluate(dictHeytingAlgebra)(v.value1));
        };
        if (v instanceof Equiv) {
            return conj1(implies(evaluate(dictHeytingAlgebra)(v.value0))(evaluate(dictHeytingAlgebra)(v.value1)))(implies(evaluate(dictHeytingAlgebra)(v.value1))(evaluate(dictHeytingAlgebra)(v.value0)));
        };
        if (v instanceof Neg) {
            return not1(evaluate(dictHeytingAlgebra)(v.value0));
        };
        throw new Error("Failed pattern match at Data.LogicExpr.AST (line 282, column 1 - line 282, column 54): " + [ v.constructor.name ]);
    };
};
var equivBoolean = {
    equiv: /* #__PURE__ */ Data_Eq.eq(Data_Eq.eqBoolean),
    HeytingAlgebra0: function () {
        return Data_HeytingAlgebra.heytingAlgebraBoolean;
    }
};
var equivB4 = {
    equiv: function (v) {
        return function (v1) {
            if (v instanceof Data_LogicValues_B4.Indeterminate) {
                return Data_LogicValues_B4.Indeterminate.value;
            };
            if (v1 instanceof Data_LogicValues_B4.Indeterminate) {
                return Data_LogicValues_B4.Indeterminate.value;
            };
            if (v instanceof Data_LogicValues_B4.Undecidable && v1 instanceof Data_LogicValues_B4.Undecidable) {
                return Data_LogicValues_B4.Undecidable.value;
            };
            if (v1 instanceof Data_LogicValues_B4.Undecidable) {
                return Data_LogicValues_B4.Undecidable.value;
            };
            if (v instanceof Data_LogicValues_B4.Undecidable) {
                return Data_LogicValues_B4.Undecidable.value;
            };
            if (eq(v)(v1)) {
                return Data_LogicValues_B4.Yes.value;
            };
            if (Data_Boolean.otherwise) {
                return Data_LogicValues_B4.No.value;
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 187, column 1 - line 194, column 31): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    HeytingAlgebra0: function () {
        return Data_LogicValues_B4.heytingAlgebraB4;
    }
};
var equiv = function (dict) {
    return dict.equiv;
};
var equivExpr = function (dictHeytingWithEquiv) {
    var equiv1 = equiv(dictHeytingWithEquiv);
    var heytingAlgebraExpr1 = heytingAlgebraExpr(dictHeytingWithEquiv.HeytingAlgebra0());
    return {
        equiv: function (v) {
            return function (v1) {
                if (v instanceof Leaf && v1 instanceof Leaf) {
                    return new Leaf(equiv1(v.value0)(v1.value0));
                };
                return new Equiv(v, v1);
            };
        },
        HeytingAlgebra0: function () {
            return heytingAlgebraExpr1;
        }
    };
};
var equivValueExpr = function (dictHeytingWithEquiv) {
    var equiv1 = equiv(dictHeytingWithEquiv);
    var heytingAlgebraValueExpr1 = heytingAlgebraValueExpr(dictHeytingWithEquiv.HeytingAlgebra0());
    return {
        equiv: function (v) {
            return function (v1) {
                if (v instanceof Leaf && (v.value0 instanceof Data_Either.Left && (v1 instanceof Leaf && v1.value0 instanceof Data_Either.Left))) {
                    return value(equiv1(v.value0.value0)(v1.value0.value0));
                };
                return new Equiv(v, v1);
            };
        },
        HeytingAlgebra0: function () {
            return heytingAlgebraValueExpr1;
        }
    };
};
var eqExpr = function (dictEq) {
    var eq1 = Data_Eq.eq(dictEq);
    return {
        eq: function (x) {
            return function (y) {
                if (x instanceof Implies && y instanceof Implies) {
                    return Data_Eq.eq(eqExpr(dictEq))(x.value0)(y.value0) && Data_Eq.eq(eqExpr(dictEq))(x.value1)(y.value1);
                };
                if (x instanceof Equiv && y instanceof Equiv) {
                    return Data_Eq.eq(eqExpr(dictEq))(x.value0)(y.value0) && Data_Eq.eq(eqExpr(dictEq))(x.value1)(y.value1);
                };
                if (x instanceof And && y instanceof And) {
                    return Data_Eq.eq(eqExpr(dictEq))(x.value0)(y.value0) && Data_Eq.eq(eqExpr(dictEq))(x.value1)(y.value1);
                };
                if (x instanceof Or && y instanceof Or) {
                    return Data_Eq.eq(eqExpr(dictEq))(x.value0)(y.value0) && Data_Eq.eq(eqExpr(dictEq))(x.value1)(y.value1);
                };
                if (x instanceof Neg && y instanceof Neg) {
                    return Data_Eq.eq(eqExpr(dictEq))(x.value0)(y.value0);
                };
                if (x instanceof Leaf && y instanceof Leaf) {
                    return eq1(x.value0)(y.value0);
                };
                return false;
            };
        }
    };
};
var eqValueExpr = function (dictEq) {
    var eqEither = Data_Either.eqEither(dictEq);
    return function (dictEq1) {
        var eq1 = Data_Eq.eq(eqExpr(eqEither(dictEq1)));
        return {
            eq: function (x) {
                return function (y) {
                    return eq1(x)(y);
                };
            }
        };
    };
};
var eq1ValueExpr = function (dictEq) {
    var eqValueExpr1 = eqValueExpr(dictEq);
    return function (dictEq1) {
        return {
            eq1: function (dictEq2) {
                return Data_Eq.eq(eqValueExpr1(dictEq2));
            }
        };
    };
};
var eq1Expr = {
    eq1: function (dictEq) {
        return Data_Eq.eq(eqExpr(dictEq));
    }
};
var ord1Expr = {
    compare1: function (dictOrd) {
        var compare2 = Data_Ord.compare(dictOrd);
        return function (v) {
            return function (v1) {
                if (v instanceof Leaf && v1 instanceof Leaf) {
                    return compare2(v.value0)(v1.value0);
                };
                if (v instanceof Implies && v1 instanceof Implies) {
                    return append1(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value0)(v1.value0))(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value1)(v1.value1));
                };
                if (v instanceof Equiv && v1 instanceof Equiv) {
                    return append1(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value0)(v1.value0))(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value1)(v1.value1));
                };
                if (v instanceof And && v1 instanceof And) {
                    return append1(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value0)(v1.value0))(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value1)(v1.value1));
                };
                if (v instanceof Or && v1 instanceof Or) {
                    return append1(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value0)(v1.value0))(Data_Ord.compare1(ord1Expr)(dictOrd)(v.value1)(v1.value1));
                };
                if (v instanceof Neg && v1 instanceof Neg) {
                    return Data_Ord.compare1(ord1Expr)(dictOrd)(v.value0)(v1.value0);
                };
                return compare(precedence(v))(precedence(v1));
            };
        };
    },
    Eq10: function () {
        return eq1Expr;
    }
};
var compare1 = /* #__PURE__ */ Data_Ord.compare1(ord1Expr);
var ordExpr = function (dictOrd) {
    var compare11 = compare1(dictOrd);
    var eqExpr1 = eqExpr(dictOrd.Eq0());
    return {
        compare: function (lhs) {
            return function (rhs) {
                return compare11(lhs)(rhs);
            };
        },
        Eq0: function () {
            return eqExpr1;
        }
    };
};
var defaultEquiv = function (dictHeytingAlgebra) {
    var conj1 = Data_HeytingAlgebra.conj(dictHeytingAlgebra);
    var implies = Data_HeytingAlgebra.implies(dictHeytingAlgebra);
    return function (lhs) {
        return function (rhs) {
            return conj1(implies(lhs)(rhs))(implies(rhs)(lhs));
        };
    };
};
var composeToValueExpr = function ($568) {
    return ValueExpr(unwrap($568));
};
var children = function (v) {
    if (v instanceof Implies) {
        return [ v.value0, v.value1 ];
    };
    if (v instanceof Equiv) {
        return [ v.value0, v.value1 ];
    };
    if (v instanceof And) {
        var go = function (v1) {
            if (v1 instanceof And) {
                return append2(go(v1.value0))(go(v1.value1));
            };
            return [ v1 ];
        };
        return go(v);
    };
    if (v instanceof Or) {
        var go = function (v1) {
            if (v1 instanceof Or) {
                return append2(go(v1.value0))(go(v1.value1));
            };
            return [ v1 ];
        };
        return go(v);
    };
    if (v instanceof Neg) {
        return [ v.value0 ];
    };
    if (v instanceof Leaf) {
        return [  ];
    };
    throw new Error("Failed pattern match at Data.LogicExpr.AST (line 86, column 1 - line 86, column 47): " + [ v.constructor.name ]);
};
var bifunctorValueExpr = {
    bimap: function (f) {
        return function (g) {
            return function (v) {
                return map1(bimap(f)(g))(v);
            };
        };
    }
};
var applyExpr = {
    apply: function (v) {
        return function (v1) {
            if (v instanceof Leaf) {
                return map1(v.value0)(v1);
            };
            if (v1 instanceof Leaf) {
                return map1(function (v2) {
                    return v2(v1.value0);
                })(v);
            };
            if (v1 instanceof Implies) {
                return new Implies(Control_Apply.apply(applyExpr)(v)(v1.value0), Control_Apply.apply(applyExpr)(v)(v1.value1));
            };
            if (v1 instanceof And) {
                return new And(Control_Apply.apply(applyExpr)(v)(v1.value0), Control_Apply.apply(applyExpr)(v)(v1.value1));
            };
            if (v1 instanceof Or) {
                return new Or(Control_Apply.apply(applyExpr)(v)(v1.value0), Control_Apply.apply(applyExpr)(v)(v1.value1));
            };
            if (v1 instanceof Equiv) {
                return new Equiv(Control_Apply.apply(applyExpr)(v)(v1.value0), Control_Apply.apply(applyExpr)(v)(v1.value1));
            };
            if (v1 instanceof Neg) {
                return new Neg(Control_Apply.apply(applyExpr)(v)(v1.value0));
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 206, column 1 - line 213, column 52): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Functor0: function () {
        return functorExpr;
    }
};
var apply = /* #__PURE__ */ Control_Apply.apply(/* #__PURE__ */ Data_Functor_Compose.applyCompose(applyExpr)(Data_Either.applyEither));
var applyValueExpr = {
    apply: function (fs) {
        return function (xs) {
            return composeToValueExpr(apply(valueExprToCompose(fs))(valueExprToCompose(xs)));
        };
    },
    Functor0: function () {
        return functorValueExpr;
    }
};
var bindExpr = {
    bind: function (v) {
        return function (v1) {
            if (v instanceof Leaf) {
                return v1(v.value0);
            };
            if (v instanceof Implies) {
                return new Implies(Control_Bind.bind(bindExpr)(v.value0)(v1), Control_Bind.bind(bindExpr)(v.value1)(v1));
            };
            if (v instanceof And) {
                return new And(Control_Bind.bind(bindExpr)(v.value0)(v1), Control_Bind.bind(bindExpr)(v.value1)(v1));
            };
            if (v instanceof Or) {
                return new Or(Control_Bind.bind(bindExpr)(v.value0)(v1), Control_Bind.bind(bindExpr)(v.value1)(v1));
            };
            if (v instanceof Equiv) {
                return new Equiv(Control_Bind.bind(bindExpr)(v.value0)(v1), Control_Bind.bind(bindExpr)(v.value1)(v1));
            };
            if (v instanceof Neg) {
                return new Neg(Control_Bind.bind(bindExpr)(v.value0)(v1));
            };
            throw new Error("Failed pattern match at Data.LogicExpr.AST (line 224, column 1 - line 230, column 51): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Apply0: function () {
        return applyExpr;
    }
};
var bind = /* #__PURE__ */ Control_Bind.bind(bindExpr);
var applicativeValueExpr = {
    pure: function (x) {
        return new Leaf(new Data_Either.Right(x));
    },
    Apply0: function () {
        return applyValueExpr;
    }
};
var applicativeExpr = {
    pure: function (x) {
        return new Leaf(x);
    },
    Apply0: function () {
        return applyExpr;
    }
};
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeExpr);
var bindValueExpr = {
    bind: function (v) {
        return function (f) {
            return bind(v)(Data_Either.either(function ($569) {
                return pure(Data_Either.Left.create($569));
            })(function ($570) {
                return unwrap(f($570));
            }));
        };
    },
    Apply0: function () {
        return applyValueExpr;
    }
};
var monadValueExpr = {
    Applicative0: function () {
        return applicativeValueExpr;
    },
    Bind1: function () {
        return bindValueExpr;
    }
};
var monadExpr = {
    Applicative0: function () {
        return applicativeExpr;
    },
    Bind1: function () {
        return bindExpr;
    }
};
export {
    Implies,
    Equiv,
    And,
    Or,
    Neg,
    Leaf,
    ValueExpr,
    children,
    composeToValueExpr,
    defaultEquiv,
    equiv,
    evaluate,
    freeTerms,
    freeTerms$prime,
    isTerm,
    isValue,
    neg$prime,
    nodeType,
    precedence,
    renderWith,
    trimBoolValues,
    value,
    valueExprToCompose,
    newtypeValueExpr,
    showExpr,
    showValueExpr,
    functorExpr,
    functorValueExpr,
    bifunctorValueExpr,
    eqExpr,
    eqValueExpr,
    eq1Expr,
    eq1ValueExpr,
    ord1Expr,
    ordExpr,
    heytingAlgebraExpr,
    heytingAlgebraValueExpr,
    equivBoolean,
    equivB4,
    equivExpr,
    equivValueExpr,
    applyExpr,
    applyValueExpr,
    applicativeExpr,
    applicativeValueExpr,
    bindExpr,
    bindValueExpr,
    monadExpr,
    monadValueExpr,
    foldableExpr,
    foldableValueExpr,
    foldable1Expr,
    traversable1Expr,
    traversableExpr
};
//# sourceMappingURL=index.js.map
